import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const NAV_HREFS = [
  { labelKey: "navAbout", href: "/about" },
  { labelKey: "navBlogs", href: "/Blogs" },
  { labelKey: "navContact", href: "/about#contactform" },
  { labelKey: "navFaqs", href: "/faq" },
  { labelKey: "navDownloadApp", href: "/downlaodapp" },
];

export function useMarketingLabels() {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      openMenu: t("Common.OpenMenu"),
      explore: t("Marketing.Explore"),
      loginSignup: t("Common.LoginSignup"),
      dropNote: t("Marketing.DropNote"),
      callDirectly: t("Marketing.CallDirectly"),
      aboutUs: t("Sidemenubar.About Us"),
      aboutUsTitle: t("Sidemenubar.About Us"),
      contactUs: t("Sidemenubar.Contact Us"),
      privacyPolicy: t("Sidemenubar.Privacy Policy"),
      faqs: t("Sidemenubar.Faqs"),
      terms: t("Sidemenubar.Terms & Conditions"),
      userAgreement: t("Sidemenubar.User Agreement"),
      allRightsReserved: t("Marketing.AllRightsReserved"),
      navAbout: t("Marketing.NavAbout"),
      navBlogs: t("Marketing.NavBlogs"),
      navContact: t("Marketing.NavContact"),
      navFaqs: t("Marketing.NavFaqs"),
      navDownloadApp: t("Marketing.NavDownloadApp"),
      phone: t("Common.Phone"),
      whatsApp: t("Common.WhatsApp"),
      aboutVideo: t("Common.AppPreviewVideo"),
      contactHotline: t("Common.ContactHotline"),
      hotlineText: t("Marketing.HotlineText"),
      contactName: t("Marketing.ContactName"),
      contactEmail: t("Marketing.ContactEmail"),
      contactMessage: t("Marketing.ContactMessage"),
      selectSubject: t("Marketing.SelectSubject"),
      submitRequest: t("Marketing.SubmitRequest"),
      submittingRequest: t("Marketing.SubmittingRequest"),
      getInTouch: t("Marketing.GetInTouch"),
    }),
    [t]
  );
}

export function useMarketingNavLinks(activeHref) {
  const labels = useMarketingLabels();

  return useMemo(
    () =>
      NAV_HREFS.map((item) => ({
        label: labels[item.labelKey],
        href: item.href,
        active: item.href === activeHref,
      })),
    [labels, activeHref]
  );
}
